import { useState, useEffect } from "react";
import dayjs from "dayjs";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import {
  InputLabel,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Button,
  Grid,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useSelector } from "react-redux";

const emptyActivityData = {
  activity_name: "",
  //   start_date: 0,
  //   end_date: 0,
  recurring_frequency: "",
  task_id: "",
  description: "",
  employee_id: "",
  percent_complete: 0,
};
export default function UpdateRecurringActivityDialog({
  open,
  setOpen,
  onUpdate,
  lowestTasks,
  employees,
  selectedActivity,
  projectData,
}) {
  const [data, setData] = useState(emptyActivityData);
  const [dateBoundry, setDateBoundry] = useState({
    start_date: "",
    end_date: "",
  });
  const user = useSelector((state) => state.user);

  const userIsNotAdminNorPM =
    projectData.pm_id !== user.roleId && user.role !== "Admin";

  const [taskEmployees, setTaskEmployees] = useState([]);

  useEffect(() => {
    if (open) setData(selectedActivity);
  }, [open]);

  const handleDataChange = (e) => {
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  useEffect(() => {
    if (data.task_id) {
      let task = lowestTasks.find((t) => t.id === data.task_id);
      //   setDateBoundry({
      //     start_date: task.start_date,
      //     end_date: task.end_date,
      //   });
      //   setData((prev) => ({
      //     ...prev,
      //     start_date: task.start_date,
      //     end_date: task.end_date,
      //   }));

      let emps = employees.filter((e) => e.task_id === data.task_id);
      setTaskEmployees(emps);
    }
  }, [data.task_id]);
  const options = ["Monthly", "Daily"];

  return (
    <Dialog
      open={open}
      onClose={() => {
        //  setOpen("UPDATE_ACTIVITY");
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Add Activity</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ pt: 2 }}>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              fullWidth
              label="Name"
              className="name-textfeild"
              name="activity_name"
              disabled={userIsNotAdminNorPM}
              value={data.activity_name}
              onChange={handleDataChange}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Task</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={data.task_id}
                label="Task"
                disabled={userIsNotAdminNorPM}
                name="task_id"
                onChange={handleDataChange}
              >
                <MenuItem value="">Choose</MenuItem>
                {lowestTasks.map((t, i) => (
                  <MenuItem key={i} value={t.id}>
                    {t.task_code} - {t.task_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label-e">Assign To</InputLabel>
              <Select
                labelId="demo-simple-select-label-e"
                id="demo-simple-select-e"
                value={data.employee_id}
                label="Assign To"
                name="employee_id"
                disabled={!taskEmployees.length || userIsNotAdminNorPM}
                onChange={handleDataChange}
              >
                <MenuItem value="">Choose</MenuItem>
                {taskEmployees.map((t, i) => (
                  <MenuItem key={i} value={t.id}>
                    {t.email}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {/* <Grid item xs={12} sm={6} md={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                 inputFormat="MM/dd/yyyy"
                label="Start Date"
                value={new Date(data.start_date).toJSON()}
                minDate={new Date(dateBoundry.start_date).toJSON()}
                maxDate={new Date(dateBoundry.end_date).toJSON()}
                disabled={userIsNotAdminNorPM}
                onChange={(newValue) => {
                  handleDataChange({
                    target: { name: "start_date", value: newValue },
                  });
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                 inputFormat="MM/dd/yyyy"
                label="End Date"
                value={new Date(data.end_date).toJSON()}
                minDate={getLaterDate(dateBoundry.start_date, data.start_date)}
                maxDate={dateBoundry.end_date}
                disabled={userIsNotAdminNorPM}
                onChange={(newValue) => {
                  handleDataChange({
                    target: { name: "end_date", value: newValue },
                  });
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Grid> */}
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              label="% Complete"
              fullWidth
              name="percent_complete"
              type="number"
              value={data.percent_complete}
              onChange={handleDataChange}
            />
          </Grid>

          <Grid item xs={12} md={12}>
            <TextField
              label="Description"
              fullWidth
              name="description"
              disabled={userIsNotAdminNorPM}
              value={data.description}
              onChange={handleDataChange}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <FormControl component="fieldset">
              <RadioGroup
                value={data.recurring_frequency}
                onChange={handleDataChange}
              >
                {options.map((option) => (
                  <FormControlLabel
                    key={option}
                    value={option}
                    name="recurring_frequency"
                    control={<Radio color="primary" />}
                    label={option}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          className="cancel-button"
          onClick={() => {
            setOpen("UPDATE_RECURRING_ACTIVITY");
          }}
        >
          Cancel
        </Button>
        <Button
          disabled={/^Trial_User$/i.test(user.role) ? true : false}
          className="blue-button"
          onClick={() => {
            onUpdate(getUpdatableActivityData(data));
          }}
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function getUpdatableActivityData(data) {
  return {
    activity_name: data.activity_name,
    // start_date: data.start_date,
    // end_date: data.end_date,
    task_id: data.task_id,
    description: data.description,
    employee_id: data.employee_id,
    percent_complete: data.percent_complete,
    recurring_frequency: data.recurring_frequency,
  };
}

function getLaterDate(d1, d2) {
  return dayjs(d1).isAfter(dayjs(d2))
    ? new Date(d1).toJSON()
    : new Date(d2).toJSON();
}

function getEarlierDate(d1, d2) {
  return dayjs(d1).isBefore(dayjs(d2))
    ? new Date(d1).toJSON()
    : new Date(d2).toJSON();
}
